import { Common, color } from '@stockbit/ui';
import Image from 'global/Image';
import { GetResearchData } from '../types';
import { ResearchBox, ResearchImage } from './styled';
import PinnedLabel from '../Post/PinnedLabel';

const { Flex, Text } = Common;

interface ResearchPostProps {
  post: GetResearchData;
  isPinned?: boolean;
}

function ResearchPost({ post, isPinned = false }: ResearchPostProps) {
  const handleClick = () => {
    window.open(post.url, '_blank', 'noopener,noreferrer');
  };

  return (
    <div>
      {isPinned && (
        <Flex pl="20px" pt="20px">
          <PinnedLabel marginBottom="12px" isCompanyPinnedPost />
        </Flex>
      )}
      <ResearchBox
        p={isPinned ? '' : '16px 0'}
        onClick={handleClick}
      >
        <Flex
          direction="column"
          align="flex-start"
          style={{ gap: '4px', flex: 1 }}
        >
          <Text
            as="h2"
            size={isPinned ? '16px' : '18px'}
            family="bold"
            weight={700}
            height="22px"
          >
            {post.title}
          </Text>
          <Flex align="center" style={{ gap: '4px' }}>
            <Image src={post.icon_url} style={{ width: 16 }} />
            <Text size={isPinned ? '12px' : '13px'} color={color.highgray} height="18px">
              {post.category_label} • {post.description}
            </Text>
          </Flex>
        </Flex>
        <ResearchImage>
          <Image src={post.image_url} />
        </ResearchImage>
      </ResearchBox>
    </div>
  );
}

export default ResearchPost;
